module.exports = __webpack_public_path__ + "static/media/Profit loss.b8de0bb2.png";